require('./CustomOverlay.scss');

const React = require('react');
const {PropTypes} = require('react');

const CustomOverlay = React.createClass({displayName: "CustomOverlay",

    propTypes: {
        show: PropTypes.bool,
        text: PropTypes.String
    },

    render() {
        const {isVisible, text} = this.props;

        let className = 'bp-custom-overlay';

        if (isVisible) {
            className += ' is-visible';
        }

        if (text) {
            className += ' has-text';
        }

        return (React.createElement("div", {"data-text": text, className: className}));
    }
});


module.exports = CustomOverlay;



/** WEBPACK FOOTER **
 ** ./src/components/CustomOverlay/CustomOverlay.js
 **/